module.exports = __webpack_public_path__ + "img/Nepal.1641799b.svg";